import { useEffect } from "react";
import Select from 'react-select';



function NotificationFilter(props) {

  useEffect(()=> {

  },[]);

  const notificationFilterList = props?.list?.map((item)=> {
    return ({...item, label:`${item?.Notification_Filter_Name}`})
  });

  
  const customStyles = {
    control: base => ({
      ...base,
      height: 50,
      backgroundColor: '#F1F1F1',
      width: 250,
    }),
    indicatorSeparator: styles => ({ ...styles, display : 'none' }),
    // placeholder: styles => ({ ...styles, display : 'none' }),
    valueContainer: styles => ({ ...styles, backgroundColor: '',height: 20, paddingBottom:"45px", marginLeft:"13px"}),
    option: styles => ({ ...styles, backgroundColor: '#F1F1F1', color:"black"}),

  
    
  }

    const handleChange = (value) => {
      props.onFilterSelect(value)
      };


    return ( 
        <>
   
         <Select   styles={customStyles} onChange={handleChange} 
          options={notificationFilterList}
         />


        </>
     );
}

export default NotificationFilter;
